import script from "./NewSensor.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSensor.vue?vue&type=script&setup=true&lang=js"

import "./NewSensor.vue?vue&type=style&index=0&id=6e87a975&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e87a975"]])

export default __exports__